/**
 * Mantine's NumberInput declares its onChange value as `string | number` and reports `''` the
 * moment a user clears the field mid-edit. This gates that right at the input boundary with the
 * field's own sensible fallback, so a momentary blank keystroke becomes a real, valid `number`
 * before it's ever stored — nothing past this point (state, validation, the calculate-endpoint
 * request) ever has to account for a blank value.
 */
export const toNumberOrDefault = (value: number | string, fallback: number): number =>
  value === '' ? fallback : Number(value);
